module.exports = __webpack_public_path__ + "kudos_72.svg?d1e300ee41012688e9f08dd35057ca8c";


//////////////////
// WEBPACK FOOTER
// ./src/assets/kudos/kudos_72.svg
// module id = 175
// module chunks = 0